// src/config.js
const h = window.location.hostname;
const isLoopback = ["localhost", "127.0.0.1", "[::1]"].includes(h);
const isPrivateIp =
    /^10\./.test(h) ||
    /^192\.168\./.test(h) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(h);
const isLocal = isLoopback || isPrivateIp;
// console.log('[\\react_pj\\src\\config.js] host=', h, { isLoopback, isPrivateIp, isLocal });

// ระบุสภาพแวดล้อมแบบง่าย
let ENV = process.env.REACT_APP_API_ENV || "local";

if (!isLocal) {
    ENV = h.includes("ndes-test") ? "test" : "prod";
}

const map = {
    local: {
        LARAVEL_BASE: process.env.REACT_APP_LARAVEL_URL_LOCAL,
        NODE_BASE: process.env.REACT_APP_NODE_URL_LOCAL,
        REACT_BASE: process.env.REACT_APP_REACT_URL_LOCAL,
    },
    test: {
        LARAVEL_BASE: process.env.REACT_APP_LARAVEL_URL_TEST,
        NODE_BASE: process.env.REACT_APP_NODE_URL_TEST,
        REACT_BASE: process.env.REACT_APP_REACT_URL_TEST,
    },
    prod: {
        LARAVEL_BASE: process.env.REACT_APP_LARAVEL_URL_PROD,
        NODE_BASE: process.env.REACT_APP_NODE_URL_PROD,
        REACT_BASE: process.env.REACT_APP_REACT_URL_PROD,
    },
};

export const { LARAVEL_BASE, NODE_BASE, REACT_BASE } = map[ENV];
